import { ActionPlanSubmissionUtils } from '../../../utils/actionPlanSubmission.utils';
import { ActionPlanStepResolver, type ActionPlanStep } from './ActionPlanStepResolver';

export interface ActionPlanStepState {
  step: ActionPlanStep;
  hasSubmitted: boolean;
}

export interface ActionPlanStepServiceInput {
  guid: string | undefined;
  isDirectActionPlanRoute: boolean;
  isCheckingBackend: boolean;
  hasAggregatedData: boolean;
}

export class ActionPlanStepService {
  public static determineStep(input: ActionPlanStepServiceInput): ActionPlanStepState {
    const { guid } = input;

    const hasLocalSubmission = guid
      ? ActionPlanSubmissionUtils.hasSubmittedActionPlan(guid)
      : false;

    const step = ActionPlanStepResolver.resolveStep({
      ...input,
      hasLocalSubmission,
    });

    return {
      step,
      hasSubmitted: hasLocalSubmission,
    };
  }

  public static shouldSyncLocalStorage(
    hasAggregatedData: boolean,
    hasLocalSubmission: boolean,
  ): boolean {
    return ActionPlanStepResolver.shouldSyncLocalStorage(
      hasAggregatedData,
      hasLocalSubmission
    );
  }

  public static syncLocalStorage(guid: string): void {
    ActionPlanSubmissionUtils.addNewActionPlanSubmission(guid);
  }
}
